import { render, staticRenderFns } from "./oripeinman.vue?vue&type=template&id=0490e589&scoped=true&"
import script from "./oripeinman.vue?vue&type=script&lang=js&"
export * from "./oripeinman.vue?vue&type=script&lang=js&"
import style0 from "./oripeinman.vue?vue&type=style&index=0&id=0490e589&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490e589",
  null
  
)

export default component.exports